// Program segmented control (DAA-2-08); "all" sends no program.
export const PROGRAM_OPTIONS = [
  { value: "all", label: "All programs" },
  { value: "cc", label: "CC" },
  { value: "oi", label: "OI" }
]

// Channel groups (DAA-2-05, DAA-2-09); "other" is every stored value outside the billable three.
export const CHANNEL_OPTIONS = [
  { id: "banking_app", name: "Banking app" },
  { id: "call_center", name: "Call center" },
  { id: "mastercom", name: "Mastercom" },
  { id: "other", name: "Other" }
]

// The page's four blocks, in order (DAA-1-07). `id` is the block's anchor for the section navigation.
export const BLOCKS = [
  {
    id: "volume",
    title: "Volume and usage",
    description: "How much the product is used and by whom"
  },
  {
    id: "matching",
    title: "Matching quality",
    description: "How well lookups are attributed"
  },
  {
    id: "money",
    title: "Money",
    description: "What the product earns and what a paying merchant brings"
  },
  {
    id: "enrollment",
    title: "Enrollment operations",
    description: "Descriptor statuses and time to Active"
  }
]

// The DOM id of a block's section.
export const blockAnchor = (id) => `deflect-block-${id}`
